import { render, staticRenderFns } from "./MocoSync.vue?vue&type=template&id=4f1d8642&lang=pug"
import script from "./MocoSync.vue?vue&type=script&lang=js"
export * from "./MocoSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports